import React, { useRef } from 'react';
import { defineBlock, smartProps, EditableText } from '@smartfire/gutenberg-react';
import useChildrenBlocks from '../shared/useChildrenBlocks';
import style from './block.module.scss';
import top from "./top.svg"
import bottom from "./bottom.svg"


function Block() {

    const ref = useRef();
    // eslint-disable-next-line no-unused-vars
    const { Children, Child , domChildren } = useChildrenBlocks({ nodeRef: ref });

    let content = <div className={domChildren && domChildren.length>2? style.threeColGrid: (domChildren && domChildren.length>1? style.twoColGrid: style.column)}><Children allowedBlocks={["smartfire/offres-child"]} className={style.reveal} /></div>;

    return <div className={style.block} ref={ref}>
        <img className={style.top} src={top} alt="" />
        <div className={style.content}>
            <EditableText className={style.title} smartProp="title" tagName="h2" allowedFormats={["core/bold", "advanced/color"]} />
            {content}
        </div>
        <img className={style.bottom} src={bottom} alt="" />
    </div>
}

export default defineBlock({
    Block,
    smartProps: {
        title: smartProps.string.withDefault("Découvrez nos offres"),
    },
    setup: {
        title: 'Offres'
    }
})
